import { stringToSlug } from '@guillotinaweb/react-gmi'

// Relative slug used by landings such as /landings/prosecco-cocktails/.
const PLAIN_LANDING_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export function isPlainLandingSlug(value) {
  return typeof value === 'string' && PLAIN_LANDING_SLUG.test(value)
}

// Absolute paths, ".html", a trailing hyphen or anything stringToSlug cannot
// turn into a plain slug. Those must be confirmed and stored unchanged:
// stringToSlug deletes "." and would turn vermouths.html into vermouthshtml.
export function isUnusualLandingSlug(value) {
  if (!value || isPlainLandingSlug(value)) return false
  if (
    value.startsWith('/') ||
    value.includes('.') ||
    value.startsWith('-') ||
    value.endsWith('-')
  ) {
    return true
  }
  return !isPlainLandingSlug(stringToSlug(value))
}

// Same rules as api.urls.landing_public_path. Relative slugs live under /content/.
export function landingPublicPath(slug, lang) {
  if (!slug) return ''
  if (slug.startsWith('/')) return slug
  return `/${lang}/content/${slug}/`
}

export function slugifyLandingValue(value) {
  if (!value) return ''
  if (value.startsWith('/')) {
    return value
      .split('/')
      .map((part) => (part ? stringToSlug(part) : ''))
      .join('/')
  }
  return stringToSlug(value)
}

export function fixSlugs(slugs) {
  return Object.entries(slugs || {}).reduce((newSlugs, [lang, slug]) => {
    newSlugs[lang] = slug || ''
    if (!slug) return newSlugs
    if (slug.startsWith('/')) {
      if (lang && !slug.startsWith(`/${lang}/`)) {
        newSlugs[lang] = slug.replace('/', `/${lang}/`)
      }
      if (!newSlugs[lang].endsWith('/')) newSlugs[lang] += '/'
      newSlugs[lang] = newSlugs[lang]
        .split('/')
        .map((part) => (part ? stringToSlug(part) : ''))
        .join('/')
    } else {
      newSlugs[lang] = stringToSlug(newSlugs[lang])
    }
    return newSlugs
  }, {})
}

export function landingRedirectsPath(path) {
  // GuillotinaClient.delete does not strip a leading slash, so the path
  // must be relative to /db/guillotina/ for get, post and delete.
  const base = path.endsWith('/') ? path.slice(0, -1) : path
  const relative = base.startsWith('/') ? base.slice(1) : base
  return `${relative}/@redirects`
}
